export default __webpack_public_path__ + "static/media/arrow-blue-up.73d52a56.svg";